export const FORM_SCHEDULE_STATUS = {
    PENDING: 0, // 2
    COMPLETED: 1, // 3
    PENDING_STATUS_FORM_MODERATION: 2,
    REFUSED: 3,
    IN_PROGRESS: 4, // 5
    PENDING_CONNECTION: 5, // 4
    PENDING_SYNC_IMAGE: 6,
    BLOCKED: -1, // 0
}

export const STORE_STATUS = {
    INCIDENCE_REPORTED_CLOSE: 9,
    INCIDENCE_REPORTED: 10,
    INCIDENCE_REPORTED_PERMANENTE: 11,
    PENDING: 0,
    PENDING_CONNECTION: 5,
    APPROVED: 1,
}

export const ORGANIZATION_STATUS = {
    PENDING_SEND: 0,
    SEND: 1,
}

export const STATUS_SEND = {
    SEND: 1,
    PENDING: 0,
}

export const CHECKIN_STATUS = {
    CHECKIN_PENDIENTE: 0,
    CHECKIN_REALIZADO: 1,
    CHECKOUT_REALIZADO: 3,
}

export const CONSTANTS_TYPES_STEPS = {
    OBJECTIVES: 'objective',
    OBJECTIVES_BY_FORMS: 'objective_by_forms',
    BLOCKED_ROUTE: 'blocked_route',
    STOPS_BY: 'stops_by',
    CHECKIN_STEPS: 'checkin_steps',
    CHECKIN_STEPS_DISTRIBUTOR: 'checkin_steps_distributor',
    CHECKOUT_STEPS: 'checkout_steps',
    OBJECTIVE_COMPLETE: 'objective_complete',
    OBJECTIVES_BY_FORMS_GROUP: 'objective_group_forms',
}

export const ID_DROPDOWN_USERS = '6595665ff72cdc1cb920efdf'

export const FORM_TYPES = {
    FORM_REFRIGERATOR: 18, // Form que levanta la question equipo
    FORM_POP_HELADERA_CHILD: 48,
    FORM_POP_HELADERA: 39, // 66a3c88f43740c52e49740e9
    FORMS: 13,
    FORM_IMAGE: 19,
    FORM_MODERACION: 40,
    FORM_REDIRECT: 43,
    FORM_INCIDENCE: 42,
    FORM_ALIAS: 47,
}
export const STATUS_PERIOD = {
    PENDING_SET_DISTRIBUTORS: 0,
    PERIOD_APROBB: 1,
    PENDING_APPROBB_DISTRIBUTORS: 2,
    PENDING_SET_WEEKS: 3,
    PENDING_APPROBB_WEEKS: 4,
    PENDING_SET_ACTIVITIES: 5,
    PENDING_APPROBB_ACTIVITIES: 6,
    PENDING_CHANGE_REQUIRED_ACTIVITIES: 7,
    PENDING_CHANGE_REQUIRED_WEEKS: 8,
    PENDING_CHANGE_REQUIRED_DISTRIBUTORS: 9,
    VACATION: 10,
    PENDING_SET_MONTHS: 11,
    STATUS_DAY_OTHER_MONTH: 12,
}
export const STATUS_KEYS = {
    KEY_DISTRIBUTOR: 'distributor',
    KEY_SET_WEEKS: 'set_weeks',
    KEY_SET_ACTIVITIES: 'set_activities',
    KEY_SET_VACATIONS: 'vacations',
    KEY_SET_MONTHS: 'month',
}
export const STATUS_MODERATION = {
    REJECTED: -1,
    PENDING: 0,
    APPROBED: 1,
    APROBBED_AGGREGATED: 2,
    VACATION: 10,
    STATUS_DAY_OTHER_MONTH: 12,
}

export const PERIOD_SEND_TYPE = {
    MONTHLY: 1,
    WEEKLY: 2,
    DAILY: 3,
}

export const FREQUENCY_TYPE = {
    MONTH: 'month',
    FORTNIGHT: 'fortnight',
    WEEKLY: 'weekly',
    DAY: 'day',
}

export const STATUS_FORM_PENDING_SYNC = {
    NO_SENDED: 0,
    SENDED: 1,
    ERROR: -1,
    IN_PROGRESS: 2,
}

/**
 * @description constante que determina la calidad de la foto. 1 es la más alta disponible, si se quiere una calidad baja se puede poner un número entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
 */
export const QUALITY_PHOTO_FORMS = 1
/**
 * @description constante que determina la calidad de la foto. 1 es la más alta disponible, si se quiere una calidad baja se puede poner un número entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
 */
export const QUALITY_PHOTO = 1
